import React from "react";
import Slide from "@mui/material/Slide";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { SnackbarProvider } from "notistack";

const SnackbarProviderWrapper = (props : any) => {
  const { t } = useTranslation();
  const notistackRef: React.Ref<SnackbarProvider> = React.createRef();

  const onClickDismiss = (key : any) => () => {
    notistackRef.current?.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
        maxSnack={5}
        anchorOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        TransitionComponent={Slide}
        ref={notistackRef}
        action={(key : any) => (<Button style={{ color: "#fff" }} onClick={onClickDismiss(key)}>{t('translations:NOTIFICATION_OK_TEXT')}</Button>)}
    >
        {props.children}
    </SnackbarProvider>
  );
};

export default SnackbarProviderWrapper;
